import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: hidden;

  .select-all-permissions-button {
    width: fit-content !important;
    background-color: ${({ theme }) => theme.brand.navy};
    color: white;
    border-radius: 10px !important;
  }
`;

const Header = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

const Attributes = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  gap: 8px;
  padding: 4px 4px 102px;
`;

export { Container, Header, Attributes };